import React, { useCallback, useState } from "react";
import Sidebar from "../profile/Sidebar";

import Navbars from "../Navbars";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";
import ErrorViewer from "../errorHandler/ErrorViewer";
import { useUpdatepostMutation } from "../../services/api";
import { useDropzone } from "react-dropzone";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
const PostingUpdate = () => {
  const navigator = useNavigate();
  const postingData = useSelector((state) => state.getPosting.data);
  const allData = useSelector((state) => state.getPosting);
  const routeParams = useParams();
  const [updatepost] = useUpdatepostMutation();
  const [is_sell, setIs_sell] = useState(false);
  const [images, setImages] = useState([]);
  const [city, setCity] = useState(1);
  const [state, setState] = useState(1);
  const [image, setimage] = useState(null);
  const [postData, setPostData] = useState();
  const [imagesPreview, setImagesPreview] = useState([]);
  const [imagePreview, setimagePreview] = useState();
  const [defaultValues, setDefaultValues] = useState({});
  console.log("mmmm1", image);
  console.log("mmmm2", images);

  const adImage = (e) => {
    console.log("img", e.target.files);
    if (e.target.name === "image") {
      const reader = new FileReader();

      reader.onload = () => {
        if (reader.readyState === 2) {
          setimagePreview(reader.result);
          setimage(...[e.target.files[0]]);
        }
      };

      reader.readAsDataURL(e.target.files[0]);
    }
  };
  const onSubmit = async (values) => {
    const formData = new FormData();
    formData.append("id", postData.id);
    formData.append("title", values.name);
    formData.append("email", values.email);
    formData.append("description", values.description);
    formData.append("number", values.phone);
    formData.append("address", values.location);
    formData.append("price", values.price);
    formData.append("city", city);
    formData.append("state", state);
    formData.append("is_sell", is_sell);
    formData.append("zipcode", values.zipCode);
    formData.append("schedule_time_start", values.S_date);
    if (values.E_date != undefined)
      formData.append("schedule_time_end", values.E_date);
    if (image!=null) {
      formData.append(`logoUpdate`, true);
      formData.append("logo", image);
    }
    else formData.append(`logoUpdate`, false);
    if (images.length > 0) {
      images.forEach((file, index) => {
        formData.append(`images`, file); // Append each file to the form data with the same key
      });
      formData.append(`imagesUpdate`, true);
    } else {
      formData.append(`imagesUpdate`, false);
    }

    formData.append("address", "address");
    formData.append("category", 1);
    formData.append("business", 2);
    console.log("form", JSON.stringify(Array.from(formData)));
    updatepost(formData)
      .unwrap()
      .then((payload) => {
        console.log(payload);

        toast.success("Post updated Successfully");
        navigator('/listing');
      })
      .catch((error) => {
        console.log(error);
        toast.success(error.data.detail);
      });
  };
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required("Username is required")
      .email("Please enter a valid email (e.g name@domain.com)."),
    name: Yup.string().required("Name is required"),
    description: Yup.string().required("Description is required"),
    phone: Yup.string().required("Phone number is required"),
    location: Yup.string().required("location is required"),
    price: Yup.string().required("price is required"),

    zipCode: Yup.string().required("zip code is required"),
    S_date: Yup.string().required("starting date is required"),
    E_date: Yup.string(),
  });
  const onChange = (e) => {
    const files = Array.from(e.target.files);
    console.log("ji", e.target.files);
    setImagesPreview([]);
    setImages(files);
    files.forEach((file) => {
      const reader = new FileReader();
  
      reader.onload = () => {
        if (reader.readyState === 2) {
          setImagesPreview((oldArray) => [...oldArray, reader.result]);
        }
      };
  
      reader.readAsDataURL(file);
    });
  };

  const methods = useForm({
    mode: "onTouched",
    resolver: yupResolver(validationSchema),
    defaultValues,
  });

  const {
    setValue,
    register,
    handleSubmit,
    formState: { errors },
  } = methods;
  const onDrop = useCallback((acceptedFiles) => {
    console.log("acceptedFiles: ", acceptedFiles[0]);
    // imagesList = [...imagesList, acceptedFiles[0]];
    // console.log("Accepted File: ", imagesList);

    // console.log("Image URL: ", URL.createObjectURL(acceptedFiles[0]));
    // setPreviewImg(URL.createObjectURL(acceptedFiles[0]));
    setImages(acceptedFiles);

    // dispatch(setFourthPage({images:acceptedFiles[0]}));
  }, []);
  useEffect(() => {
    let data = postingData.filter((val) => {
      if (val.id == routeParams.id) return val;
    });
    setPostData(data[0]);
    setValue("name", data[0].title);
    setValue("email", data[0].email);
    setValue("description", data[0].description);
    setValue("phone", data[0].number);
    setValue("location", data[0].address);
    setValue("price", data[0].price);
    setCity(1);
    setState(1);

    setValue("zipCode", data[0].zipcode);
    const d = new Date(data[0].schedule_time_start);
    setValue("S_date", d.toLocaleDateString());
    setIs_sell(data[0].is_sell);
    setimagePreview(data[0].logo[0].cdn_link);

    if (data[0].Media.length > 0) {
      let imgs = [];
      data[0].Media.forEach((val) => {
        imgs.push(val.cdn_link);
      });
      setImagesPreview(imgs);
    }
    console.log("data", data[0]);
  }, []);
  return (
    <div className="conatiner-fluid" style={{ backgroundColor: "#F5F5F5" }}>
      <Navbars />
      <div className="d-flex gap-5 pe-3 main_div">
        <Sidebar />
        <div
          className="inner2_div ps-3 pe-3 pb-5 mb-5"
          style={{
            boxShadow: "none",
            border: "1px solid rgba(188, 188, 188, 0.3)",
            borderRadius: "10px",
            marginTop: "85px",
          }}
        >
          <div className="post-card d-flex jusitfy-content-center align-items-center flex-column">
            <div className=" tab_inner tab_inner1">
              <ul className="nav nav-pills " id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    onClick={() => setIs_sell(false)}
                    className=" nav-link active list_tab"
                    id="pills-home-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-home"
                    type="button"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="true"
                    style={{ color: "#1CAC19", fontSize: "12px" }}
                  >
                    POSTING
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    onClick={() => setIs_sell(true)}
                    className="nav-link list_tab"
                    id="pills-profile-tab list_tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-profile"
                    type="button"
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected="false"
                    style={{ color: "#1CAC19", fontSize: "12px" }}
                  >
                    BUY & SELL
                  </button>
                </li>
              </ul>
            </div>
            <div className="d-flex w-100 my-2 flex-sm-column flex-md-row">
              <div className="w-md-50 w-100 d-flex flex-column my-2 px-3">
                <label className="signin-label">Name</label>
                <input
                  className={` add_search error${Boolean(
                    errors.name
                  )} business_search upper_input px-0`}
                  type="name"
                  placeholder="Enter Name"
                  {...register("name")}
                ></input>
                {errors.name && <ErrorViewer message={errors.name.message} />}
              </div>
              <div className="w-md-50 w-100 d-flex flex-column my-2 px-3">
                <label className="signin-label">Email</label>
                <input
                  className={` add_search error${Boolean(
                    errors.email
                  )} business_search upper_input px-0`}
                  placeholder="Enter email"
                  type="email"
                  {...register("email")}
                ></input>
                {errors.email && <ErrorViewer message={errors.email.message} />}
              </div>
            </div>
            <div className="d-flex w-100 my-2 flex-sm-column flex-md-row">
              <div className="w-md-50 w-100 d-flex flex-column my-2 px-3">
                <label className="signin-label">Description</label>
                <textarea
                  className={` add_search error${Boolean(
                    errors.description
                  )} business_search upper_input px-0`}
                  type="description"
                  placeholder="Enter description"
                  {...register("description")}
                ></textarea>
                {errors.description && (
                  <ErrorViewer message={errors.description.message} />
                )}
              </div>
              <div className="w-md-50 w-100 d-flex flex-column my-2 px-3">
                <label className="signin-label">Phone</label>
                <input
                  className={` add_search error${Boolean(
                    errors.phone
                  )} business_search upper_input px-0`}
                  type="phone"
                  placeholder="Enter phone number"
                  {...register("phone")}
                ></input>
                {errors.phone && <ErrorViewer message={errors.phone.message} />}
              </div>
            </div>
            <div className="d-flex w-100 my-2 flex-sm-column flex-md-row">
              <div className="w-md-50 w-100 d-flex flex-column my-2 px-3">
                <label className="signin-label">location</label>
                <input
                  className={` add_search error${Boolean(
                    errors.location
                  )} business_search upper_input px-0`}
                  type="location"
                  placeholder="Enter location"
                  {...register("location")}
                ></input>
                {errors.location && (
                  <ErrorViewer message={errors.location.message} />
                )}
              </div>
              <div className="w-md-50 w-100 d-flex flex-column my-2 px-3">
                <label className="signin-label">Price</label>
                <input
                  className={` add_search error${Boolean(
                    errors.price
                  )} business_search upper_input px-0`}
                  type="price"
                  placeholder="Enter price"
                  {...register("price")}
                ></input>
                {errors.price && <ErrorViewer message={errors.price.message} />}
              </div>
            </div>
            <div className="d-flex w-100 my-2 flex-sm-column flex-md-row">
              <div className="w-md-50 w-100 d-flex flex-column my-2 px-3">
                <label className="signin-label">City</label>
                <select
                  className="add_search business_search upper_input px-0"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                >
                  {allData?.city.map((val, ind) => (
                    <option value={val.id} key={ind}>
                      {val.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="w-md-50 w-100 d-flex flex-column my-2 px-3">
                <label className="signin-label">State</label>
                <select
                  className="add_search business_search upper_input px-0"
                  value={state}
                  onChange={(e) => setState(e.target.value)}
                >
                  {allData?.state.map((val, ind) => (
                    <option value={val.id} key={ind}>
                      {val.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="d-flex w-100 my-2 flex-sm-column flex-md-row">
              <div className="w-md-50 w-100 my-2 px-3">
                <label htmlFor="image_upload">Logo</label>
                <div className=" align-items-center">
                  <div className="custom-file">
                    <input
                      type="file"
                      name="image"
                      className="custom-file-input"
                      id="customFile"
                      accept="image/*"
                      onChange={adImage}
                    />
                    {imagePreview && (
                      <figure className="image mr-3 item-rtl">
                        <img
                          src={imagePreview}
                          className="mt-3 mr-2"
                          width="55"
                          height="52"
                          alt="image Preview"
                        />
                      </figure>
                    )}
                  </div>
                </div>
              </div>
              <div className="w-md-50 w-100 my-2 px-3">
                <label>Images</label>

                <div className="custom-file">
                  <input
                    type="file"
                    name="product_images"
                    className="custom-file-input"
                    id="customFile"
                    onChange={onChange}
                    multiple
                  />
                </div>

                {imagesPreview.map((img) => (
                  <img
                    src={img}
                    key={img}
                    alt="Images Preview"
                    className="mt-3 mr-2"
                    width="55"
                    height="52"
                  />
                ))}
              </div>
            </div>
            <div className="d-flex w-100 my-2 flex-sm-column flex-md-row">
              <div className="w-md-50 w-100 d-flex flex-column my-2 px-3">
                <label className="signin-label">zip code</label>
                <input
                  className={` add_search error${Boolean(
                    errors.zipCode
                  )} business_search upper_input px-0`}
                  type="zipCode"
                  placeholder="Enter zipcode"
                  {...register("zipCode")}
                ></input>
                {errors.zipCode && (
                  <ErrorViewer message={errors.zipCode.message} />
                )}
              </div>
              <div className="d-flex w-md-50 w-100 flex-sm-column flex-md-row px-3 my-2 gap-3">
                <div className="w-md-25 w-100 d-flex flex-column  ">
                  <label className="signin-label">
                    {is_sell == true ? "Starting date" : "Post Published"}
                  </label>
                  <input
                    id="startDate"
                    class="form-control"
                    type="date"
                    {...register("S_date")}
                  />
                  {errors.S_date && (
                    <ErrorViewer message={errors.S_date.message} />
                  )}
                </div>
                {is_sell == true ? (
                  <div className="w-md-25 w-100 d-flex flex-column ">
                    <label className="signin-label">Ending date</label>
                    <input
                      id="endDate"
                      class="form-control"
                      type="date"
                      {...register("E_date")}
                    />
                    {errors.E_date && (
                      <ErrorViewer message={errors.E_date.message} />
                    )}
                  </div>
                ) : null}
              </div>
            </div>

            <button
              className="ad_btn mt-2 mx-auto"
              onClick={handleSubmit(onSubmit)}
            >
              Update Post
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostingUpdate;